import { Tooltip } from '@chakra-ui/react';
import React from 'react';

import {
    LeftNavButtonUI,
    LeftNavButtonText
} from './left-nav-button.styled';
import { ModuleTypes } from '@api';
import {
    TeacherAdminIcon,
    TeacherAdminIcons
} from '@components';

export type OpenModuleOptions = {
    groupId?: string | null
    moduleId?: number | null
    moduleType: ModuleTypes
    moduleIds?: Array<number>
};

export type LeftNavButtonProps = {
    /**
     * Used to determine the style of an opened module.
     */
    isActive?: boolean
    /**
     * Callback used to open a portal module.
     */
    onOpenModule: (options: OpenModuleOptions) => any
    /**
     * The unique module id of the button.
     */
    moduleId: number | undefined
    /**
     * The group id of the button.
     */
    groupId: string | undefined
    /**
     * The location src of the svg icon image to load.
     */
    icon: TeacherAdminIcons
    /**
     * The button text to display.
     */
    text: string | undefined
    /**
     * The text used to display a tooltip.
     */
    tooltip: string | undefined
    /**
     * The module type used to determine how it links.
     */
    moduleType: ModuleTypes
    /**
     * The module ids under a group.
     */
     moduleIds: Array<number>
    /**
     * The link to open the module.
     */
     moduleLink: string | undefined
    /**
     * The module available only for one roster school.
     */
    isAvailableForOneRosterSchoolOnly: boolean | undefined
    /**
     * The module hidden for one roster school.
     */
    isHiddenForOneRosterSchool: boolean | undefined
};

/**
 * The individual buttons rendered in the main LeftNav sidebar.
 */
export const LeftNavButton = ({
    text,
    icon,
    moduleId,
    groupId,
    moduleType,
    isActive = false,
    tooltip,
    onOpenModule
}: LeftNavButtonProps) => {
    const handleClick = () => {
        onOpenModule({
            ...groupId && { groupId },
            ...moduleId && { moduleId },
            moduleType
        });
    };

    return (
        <Tooltip
            label={tooltip}
            placement={'right'}
            openDelay={500}
            hasArrow={true}
            closeOnMouseDown={true}
            closeOnScroll={true}
        >
            <LeftNavButtonUI
                data-testid={`leftNavButtonTest-${moduleId}`}
                tabIndex={0}
                role={'menuitem'}
                className={isActive ? 'active' : undefined}
                onClick={handleClick}
            >
                <TeacherAdminIcon
                    icon={icon}
                    width={25}
                />
                <LeftNavButtonText>
                    {text}
                </LeftNavButtonText>
            </LeftNavButtonUI>
        </Tooltip>
    );
};
